<template>
  <div class="dashboard">
    <div class="dashboard__container">
      <div class="dashboard__container--header">
        <h1>Reports</h1>
        <span class="flex align-center flex-wrap">
          <router-link :to="{name: 'payrollQueue'}">
            <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isPayrollQueue, 'btn__outlined': !isPayrollQueue }">Payroll Queue</button>
          </router-link>
          <router-link :to="{name: 'paidAssignments'}">
            <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isPaidAssignments, 'btn__outlined': !isPaidAssignments }">Paid Assignments</button>
          </router-link>
          <router-link :to="{name: 'backgroundChecks'}">
            <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isBackgroundChecks, 'btn__outlined': !isBackgroundChecks }">Background Checks</button>
          </router-link>
          <router-link :to="{name: 'payables'}">
            <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isPayables, 'btn__outlined': !isPayables }">Payables</button>
          </router-link>
          <router-link :to="{name: 'onboardingEmployees'}">
            <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isOnboardingEmployees, 'btn__outlined': !isOnboardingEmployees }">Onboarding Employees</button>
          </router-link>

          

          
          <!-- <router-link :to="{name: 'nonContractors'}">
            <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isNonContractors, 'btn__outlined': !isNonContractors }">Non Contractors</button>
          </router-link> -->
          <!-- <router-link :to="{name: 'userParse'}">
            <button class="btn  ml-3" v-bind:class="{ 'btn__dark': isUserParse, 'btn__outlined': !isUserParse }">User Parse</button>
          </router-link> -->
          <!-- <router-link :to="{name: 'clientContacts'}">
            <button class="btn  ml-3" v-bind:class="{ 'btn__dark': isContacts, 'btn__outlined': !isContacts }">Contacts</button>
          </router-link>
          <router-link :to="{name: 'clientNotes'}">
            <button class="btn  ml-3" v-bind:class="{ 'btn__dark': isNotes, 'btn__outlined': !isNotes }">Notes</button>
          </router-link>
           <router-link :to="{name: 'clientVenues'}">
            <button class="btn  ml-3" v-bind:class="{ 'btn__dark': isVenues, 'btn__outlined': !isVenues }">Venues</button>
          </router-link>
          <router-link :to="{name: 'clientFiles'}">
            <button class="btn  ml-3" v-bind:class="{ 'btn__dark': isFiles, 'btn__outlined': !isFiles }">Files</button>
          </router-link> -->
          <button class="btn btn__outlined btn__small" @click="goBack()"><i class="fas fa-arrow-left"></i></button>
        </span>
        
      </div>
      <router-view :key="$route.params.id" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import router from '@/router'

export default {
  name: 'reportsHome',
  computed: {
    ...mapState(['currentUser', 'userProfile']),
    isPayrollQueue() {
      return this.$route.name == 'payrollQueue';
    },
    isBackgroundChecks() {
      return this.$route.name == 'backgroundChecks';
    },
    isEvereeUsersWithoutExternalId() {
      return this.$route.name == 'evereeUsersWithoutExternalId';
    },
    isNonContractors() {
      return this.$route.name == 'nonContractors';
    },
    isOnboardingEmployees() {
      return this.$route.name == 'onboardingEmployees';
    },
    isPaidAssignments() {
      return this.$route.name == 'paidAssignments';
    },
    isPayables() {
      return this.$route.name == 'payables';
    },


    


    
    // isUserParse() {
    //   return this.$route.name == 'userParse';
    // },
    // isSummary() {
    //   return this.$route.name == 'client';
    // },
    // isNotes() {
    //   return this.$route.name == 'clientNotes';
    // },
    // isVenues() {
    //   return this.$route.name == 'clientVenues';
    // },
    // isFiles() {
    //   return this.$route.name == 'clientFiles';
    // }
  },
  methods: {
    goBack() {
      router.go(-1)
    },
  },
  beforeDestroy () {
    console.log(this)
  }
}
</script>